import { DateRangeFilter, StatusFilter } from '@synergy/components';
import { DocumentStatus, UserRole } from '@synergy/models';
import { PaloFilterModal } from '@synergy/components-palo';
import { ReactElement } from 'react';

import { AccessControl } from '../../../common/components/access-control/access-control';
import { CustomerContactFilter } from '../../../common/components/filter/customer-contact-filter';

/** As the legacy filter, without its search field — the list header owns that. */
export const PaloInquiryOverviewFilter = (): ReactElement => (
    <PaloFilterModal>
        <DateRangeFilter untilField="createdAtUntil" fromField="createdAtFrom" />
        <AccessControl allowedRoles={UserRole.ShopAdmin}>
            <CustomerContactFilter />
        </AccessControl>
        <StatusFilter documentStatus={[DocumentStatus.Completed, DocumentStatus.Ongoing]} />
    </PaloFilterModal>
);
